import { Skeleton } from './ui/skeleton';

interface OrderFeedSkeletonProps {
  topBarHeight?: number;
}

export function OrderFeedSkeleton({ topBarHeight = 60 }: OrderFeedSkeletonProps) {
  return (
    <div
      style={{
        backgroundColor: 'white',
        paddingTop: `calc(${topBarHeight}px + 14px)`,
      }}
    >
      {/* Section Header Skeleton */}
      <div
        style={{
          paddingLeft: '20px',
          paddingRight: '20px',
          paddingBottom: '14px',
          backgroundColor: '#F3EBFF',
        }}
      >
        <Skeleton
          delay={0}
          style={{
            height: '24px',
            width: '120px',
            borderRadius: '8px',
          }}
        />
      </div>

      {/* Order Items Skeleton */}
      <div
        style={{
          backgroundColor: '#F3EBFF',
          paddingLeft: '16px',
        }}
      >
        {[1, 2, 3, 4, 5].map((index) => (
          <div
            key={index}
            style={{
              backgroundColor: index === 1 ? '#ffffff' : '#FAF5FF',
              borderTop: '1px solid var(--neutral-200)',
              borderLeft: '1px solid var(--neutral-200)',
              borderRight: '1px solid var(--neutral-200)',
              paddingLeft: '16px',
              paddingRight: '16px',
              paddingTop: '12px',
              paddingBottom: '12px',
              borderTopLeftRadius: index === 1 ? '16px' : '0',
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: 'space-between',
                gap: '12px',
                marginBottom: '6px',
              }}
            >
              {/* Left side: Dot + Name */}
              <div style={{ flex: 1, minWidth: 0 }}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    marginBottom: '4px',
                  }}
                >
                  <Skeleton
                    delay={index * 50}
                    style={{
                      width: '9px',
                      height: '9px',
                      borderRadius: '50%',
                    }}
                  />
                  <Skeleton
                    delay={index * 50 + 20}
                    style={{
                      height: '16px',
                      width: `${120 + (index * 8)}px`,
                      borderRadius: '4px',
                    }}
                  />
                </div>
                {/* Category */}
                <div style={{ marginLeft: '17px' }}>
                  <Skeleton
                    delay={index * 50 + 40}
                    style={{
                      height: '14px',
                      width: `${100 + (index * 6)}px`,
                      borderRadius: '4px',
                    }}
                  />
                </div>
              </div>
            </div>

            {/* Meta Info */}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                marginLeft: '17px',
                marginBottom: '8px',
              }}
            >
              <Skeleton
                delay={index * 50 + 60}
                style={{
                  height: '12px',
                  width: `${80 + (index * 5)}px`,
                  borderRadius: '4px',
                }}
              />
            </div>

            {/* Badges */}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                marginLeft: '17px',
              }}
            >
              {index === 1 && (
                <Skeleton
                  delay={index * 50 + 80}
                  style={{
                    height: '24px',
                    width: '100px',
                    borderRadius: '6px',
                  }}
                />
              )}
              {index <= 2 && (
                <Skeleton
                  delay={index * 50 + 100}
                  style={{
                    height: '20px',
                    width: '60px',
                    borderRadius: '6px',
                  }}
                />
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Divider */}
      <div
        className="w-full border-t"
        style={{ borderColor: 'var(--border)' }}
      />

      {/* Second Section - Para Você */}
      <div
        style={{
          paddingLeft: '20px',
          paddingRight: '20px',
          paddingTop: '14px',
          paddingBottom: '14px',
          backgroundColor: '#D1FAE7',
        }}
      >
        <Skeleton
          delay={100}
          style={{
            height: '24px',
            width: '140px',
            borderRadius: '8px',
          }}
        />
      </div>

      <div
        style={{
          backgroundColor: '#D1FAE7',
          paddingLeft: '16px',
        }}
      >
        {[1, 2, 3].map((index) => {
          const baseDelay = 300 + (index * 50);
          return (
            <div
              key={index}
              style={{
                backgroundColor: index === 1 ? '#ffffff' : '#F9FFF9',
                borderTop: '1px solid var(--neutral-200)',
                borderLeft: '1px solid var(--neutral-200)',
                borderRight: '1px solid var(--neutral-200)',
                paddingLeft: '16px',
                paddingRight: '16px',
                paddingTop: '12px',
                paddingBottom: '12px',
                borderTopLeftRadius: index === 1 ? '16px' : '0',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  justifyContent: 'space-between',
                  gap: '12px',
                  marginBottom: '6px',
                }}
              >
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      marginBottom: '4px',
                    }}
                  >
                    <Skeleton
                      delay={baseDelay}
                      style={{
                        width: '9px',
                        height: '9px',
                        borderRadius: '50%',
                      }}
                    />
                    <Skeleton
                      delay={baseDelay + 20}
                      style={{
                        height: '16px',
                        width: `${120 + (index * 8)}px`,
                        borderRadius: '4px',
                      }}
                    />
                  </div>
                  <div style={{ marginLeft: '17px' }}>
                    <Skeleton
                      delay={baseDelay + 40}
                      style={{
                        height: '14px',
                        width: `${100 + (index * 6)}px`,
                        borderRadius: '4px',
                      }}
                    />
                  </div>
                </div>
              </div>

              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  marginLeft: '17px',
                  marginBottom: '8px',
                }}
              >
                <Skeleton
                  delay={baseDelay + 60}
                  style={{
                    height: '12px',
                    width: `${80 + (index * 5)}px`,
                    borderRadius: '4px',
                  }}
                />
              </div>

              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  marginLeft: '17px',
                }}
              >
                {index === 1 && (
                  <Skeleton
                    delay={baseDelay + 80}
                    style={{
                      height: '24px',
                      width: '100px',
                      borderRadius: '6px',
                    }}
                  />
                )}
              </div>
            </div>
          );
        })}
      </div>

      {/* Divider */}
      <div
        className="w-full border-t"
        style={{ borderColor: 'var(--border)' }}
      />

      {/* Third Section - Outros */}
      <div
        style={{
          paddingLeft: '20px',
          paddingRight: '20px',
          paddingTop: '14px',
          paddingBottom: '14px',
          backgroundColor: '#F0F2F5',
          borderTop: '1px solid var(--border)',
        }}
      >
        <Skeleton
          delay={200}
          style={{
            height: '24px',
            width: '100px',
            borderRadius: '8px',
          }}
        />
      </div>

      <div
        style={{
          backgroundColor: '#F0F2F5',
          paddingLeft: '16px',
        }}
      >
        {[1, 2, 3, 4].map((index) => {
          const baseDelay = 500 + (index * 50);
          return (
            <div
              key={index}
              style={{
                backgroundColor: index === 1 ? '#ffffff' : '#F9FAFB',
                borderTop: '1px solid var(--neutral-200)',
                borderLeft: '1px solid var(--neutral-200)',
                borderRight: '1px solid var(--neutral-200)',
                paddingLeft: '16px',
                paddingRight: '16px',
                paddingTop: '12px',
                paddingBottom: '12px',
                borderTopLeftRadius: index === 1 ? '16px' : '0',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  justifyContent: 'space-between',
                  gap: '12px',
                  marginBottom: '6px',
                }}
              >
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      marginBottom: '4px',
                    }}
                  >
                    <Skeleton
                      delay={baseDelay}
                      style={{
                        width: '9px',
                        height: '9px',
                        borderRadius: '50%',
                      }}
                    />
                    <Skeleton
                      delay={baseDelay + 20}
                      style={{
                        height: '16px',
                        width: `${120 + (index * 8)}px`,
                        borderRadius: '4px',
                      }}
                    />
                  </div>
                  <div style={{ marginLeft: '17px' }}>
                    <Skeleton
                      delay={baseDelay + 40}
                      style={{
                        height: '14px',
                        width: `${100 + (index * 6)}px`,
                        borderRadius: '4px',
                      }}
                    />
                  </div>
                </div>
              </div>

              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  marginLeft: '17px',
                  marginBottom: '8px',
                }}
              >
                <Skeleton
                  delay={baseDelay + 60}
                  style={{
                    height: '12px',
                    width: `${80 + (index * 5)}px`,
                    borderRadius: '4px',
                  }}
                />
              </div>

              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  marginLeft: '17px',
                }}
              >
                {index === 1 && (
                  <Skeleton
                    delay={baseDelay + 80}
                    style={{
                      height: '24px',
                      width: '100px',
                      borderRadius: '6px',
                    }}
                  />
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
